var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_72_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.749 1.40586C57.8746 -0.46854 54.5941 -0.46854 52.7197 1.40586C48.5021 6.09198 13.8242 48.2677 13.8242 69.8243C13.8242 93.2553 32.5689 112 55.9999 112C79.431 112 98.1756 93.2553 98.1756 69.8243C98.1756 48.2677 63.498 6.09198 59.749 1.40586Z",
    fill: "#07C4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.021 51.5482C85.9917 53.4226 85.0544 60.4518 76.1507 60.4518C65.8412 60.4518 65.8412 51.0794 56.0002 51.0794C46.1592 51.0794 45.6904 60.4518 35.8494 60.4518C26.9457 60.4518 26.0084 53.4226 18.9791 51.5482C16.1674 57.1716 14.293 63.2636 13.8242 69.8243C13.8242 71.2301 13.8242 73.1046 14.2928 74.5104C14.7613 74.5104 15.2301 74.5104 15.6986 74.5104C26.0082 74.5104 26.0082 83.8829 35.8492 83.8829C45.6902 83.8829 46.1587 74.5104 55.9997 74.5104C65.8407 74.5104 66.3093 83.8829 76.1503 83.8829C85.9913 83.8829 86.4602 74.5104 96.3012 74.5104C96.7698 74.5104 97.2386 74.5104 97.7071 74.5104C97.7071 73.1046 98.1756 71.2301 98.1756 69.8243C97.7071 63.2636 95.8327 57.1716 93.021 51.5482Z",
    fill: "#4ED6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1507 83.8829C65.8411 83.8829 65.8411 74.5104 56.0001 74.5104C46.1591 74.5104 45.6904 83.8829 35.8494 83.8829C26.0084 83.8829 25.5398 74.5104 15.6988 74.5104C15.2303 74.5104 14.7615 74.5104 14.293 74.5104C17.1047 97.4727 37.724 114.343 61.1548 111.531C80.8368 109.188 95.8327 93.7239 98.1756 74.5104C97.7071 74.5104 97.2383 74.5104 96.7698 74.5104C86.4602 74.5104 86.4602 83.8829 76.1507 83.8829Z",
    fill: "#8DE4FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDrop);
export default __webpack_public_path__ + "static/media/water-drop.b88e5d717c0d03872da32b5731cf0351.svg";
export { ForwardRef as ReactComponent };